/**
 * Hardware model mapping from hwBuildInfoProtoField
 */
export const HARDWARE_MODEL_MAP = {
  0: 'UNKNOWN',
  1: '2023 MY REKKIE Goggles',
  2: '2024 MY REKKIE Goggles',
  3: '2025 MY REKKIE Goggles',
  4: '2026 MY REKKIE Goggles',
  5: '2027 MY REKKIE Goggles'
};

/**
 * Get hardware model name from hwBuildInfoProtoField
 * @param {number|string|null|undefined} hwBuildInfoProtoField - Hardware build info field
 * @returns {string|null} Hardware model name or null
 */
export const getHardwareModel = (hwBuildInfoProtoField) => {
  if (hwBuildInfoProtoField === null || hwBuildInfoProtoField === void 0) {
    return null;
  }
  return HARDWARE_MODEL_MAP[hwBuildInfoProtoField] || 'UNKNOWN';
};
